import {AnyAction} from 'redux';
import Types from '../../actions/Types';

import FullScreenIllustration from '../../../domain/entities/FullScreenIllustration';

export default function reducer(
  state: {[key: number]: FullScreenIllustration} = {},
  action: AnyAction,
): {[key: number]: FullScreenIllustration} {
  switch (action.type) {
    case Types.ResetWriterCurrentUser:
      return {};
    case Types.IndexFullScreenIllustrationsSuccess:
      return {
        ...state,
        ...action.payload.records.reduceRight(
          (
            obj: {[key: number]: FullScreenIllustration},
            record: FullScreenIllustration,
          ) => {
            obj[record.id] = record;
            return obj;
          },
          {},
        ),
      };
    default:
      return state;
  }
}
